import {
  getActiveSpace,
  getStateSliceFor
} from 'redux/Studio';

// action constants
export const UPDATE_SHOW_RESTYLE_MODAL = 'SHOWROOM/UPDATE_SHOW_RESTYLE_MODAL';
export const UPDATE_SHOW_FAVORITES_LIST = 'SHOWROOM/UPDATE_SHOW_FAVORITES_LIST';
export const UPDATE_IS_RESTYLING = 'SHOWROOM/UPDATE_IS_RESTYLING';

// actions
export const updateShowRestyleModal = (show) => ({
  type: UPDATE_SHOW_RESTYLE_MODAL,
  payload: show
});

export const updateShowFavoritesList = show => ({
  type: UPDATE_SHOW_FAVORITES_LIST,
  payload: show
});

export const updateIsRestyling = isRestyling => ({
  type: UPDATE_IS_RESTYLING,
  payload: isRestyling
});

// State & Reducer
export const initialState = {
  isRestyling: false, // denotes a restyle is in process
  learnMoreOverlayType: null, // determine what info should show in overlay
  showFavoritesList: false, // determine what info should show in overlay
  showRestyleModal: false // restyle modals
};

export const reducerKey = 'studioShowroom';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SHOW_RESTYLE_MODAL:
      return {
        ...state,
        showRestyleModal: action.payload
      };

    case UPDATE_SHOW_FAVORITES_LIST:
      return {
        ...state,
        showFavoritesList: action.payload
      };

    case UPDATE_IS_RESTYLING:
      return {
        ...state,
        isRestyling: action.payload
      };

    default:
      return state;
  }
};

// selectors
const extractFrom = state => getStateSliceFor({ state, reducerKey });

export const getShowRestyleModal = state => extractFrom(state).showRestyleModal;
export const getRenderOverlayType = state => extractFrom(state).learnMoreOverlayType;
export const getShowFavoritesList = state => extractFrom(state).showFavoritesList;
export const getIsRestyling = state => extractFrom(state).isRestyling;

/**
 * Launch restyle.
 */
export const launchRestyle = () => (dispatch, getState) => {
  const space = getActiveSpace({ state: getState() });
  if (!space) {
    return; // nothing to do
  }

  // Only one restyle allowed at a time.
  const isRestyling = getIsRestyling(getState());
  if (isRestyling) {
    return;
  }

  // Check for conditions under which we should show
  // one of the restyle modals instead of launching
  // an actual restyle.
  if (!space.restyleInstructionsViewed()) {
    dispatch(updateShowRestyleModal(true));
    return;
  }

  // Set restyling flag on.
  // This will trigger the restyle workflow in the RestylingOverlayController.
  // Managing the restyle workflow in a component so we can resume polling
  // on page visibilitychange events.
  dispatch(updateIsRestyling(true));
};
